import React from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from 'store/notifications/action';

const Notification = ({ notification, closeNotification }) => {

	const icon = () => {
		switch (notification && notification.icon) {
			case "success":
				return (
					<svg className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
					</svg>
				)
			case "warning":
				return (
					<svg className="h-6 w-6 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.93 19.07A10 10 0 1 1 19.07 4.93 10 10 0 0 1 4.93 19.07zm1.41-1.41A8 8 0 1 0 17.66 6.34 8 8 0 0 0 6.34 17.66zM13.41 12l1.42 1.41a1 1 0 1 1-1.42 1.42L12 13.4l-1.41 1.42a1 1 0 1 1-1.42-1.42L10.6 12l-1.42-1.41a1 1 0 1 1 1.42-1.42L12 10.6l1.41-1.42a1 1 0 1 1 1.42 1.42L13.4 12z" />
					</svg>
				)
		}
	}

	const closeNotificationOnClick = () => {
		console.log('closeNotification', notification.id)
		closeNotification(notification.id);
	}

	/*x-transition:enter="transform ease-out duration-300 transition" x-transition:enter-start="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" x-transition:enter-end="translate-y-0 opacity-100 sm:translate-x-0" x-transition:leave="transition ease-in duration-100" x-transition:leave-start="opacity-100" x-transition:leave-end="opacity-0" */
	return (
		<div className="inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:pb-0 sm:items-start sm:justify-end z-50">
			<div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
				<div className="rounded-lg shadow-xs overflow-hidden">
					<div className="p-4">
						<div className="flex items-start">
							<div className="flex-shrink-0">
								{icon()}
							</div>
							<div className="ml-3 w-0 flex-1 pt-0.5">
								<p className="text-sm leading-5 font-medium text-gray-900">
									{notification && notification.title}
								</p>
								<p className="mt-1 text-sm leading-5 text-gray-500">
									{notification && notification.message}
								</p>
							</div>
							<div className="ml-4 flex-shrink-0 flex">
								<button onClick={closeNotificationOnClick} className="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150">
									<svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
										<path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
									</svg>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}


const mapStateToProps = (state) => {
	return {

	}
}

const mapDispatchToProps = dispatch => ({
	// addNotification: (notification,removeAfter) => dispatch(ACTIONS.addNotification(notification,removeAfter)),
	closeNotification: (id) => dispatch(ACTIONS.closeNotification(id)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Notification)